import '../grower/landDetailsReg/landDetails.css';
import React, { useState, useEffect } from "react";

import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { typeNumberValid, nameValidation, VALIDATION, landAreaValidation, mobileNumberValidation, pincodeValidation } from '../../../../common/commonValidations';
import { EMPTY_FIELD_ERROR, API_DATE_FORMAT, LAND_AREA_ERROR, PINCODE_NO_ERROR, BLOCK_LIST, REVENUE_CIRCLE, SAVE_EXIT_API, MOBILE_NO_ERROR, BASIC_DATE_FORMAT, LAND_AREA_UNIT, UPLOAD_FILE_TEXT, SOURCING, LAND_DOCUMENT } from "../../../../common/constants";
import { CommonPincodeMUI } from "../../../../common/common-pincode/commonPincodeMUI";
import { BambooSpeciesPopover } from '../../../../preregcamps/confirmPopover/bambooSpeciesPopover';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogContent, IconButton, Dialog, DialogActions, Switch, Table, TableBody, TableCell, Collapse, Paper, TableContainer, TableHead, TableRow, } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { confirmAlert } from 'react-confirm-alert';
import Multiselect from "multiselect-react-dropdown";
import { useNavigate, useLocation } from "react-router-dom";
import { UPDATE_GROWER, GET_AVAILABLE_COUPES, GET_GROWER_BY_URN, GET_FELLING_SERIES, GET_GROWER_BAMBOO_SPECIES, ResourceUpdateMember } from '../../../../common/URLs'
import { loaderService } from '../../../../common/custom-loader/loader-service';
import cross from "../../../../images/cross.png";
import { downloadDocument, uploadDocument } from '../../../../common/Utils';
import jwt from 'jwt-decode';
import { FileUpload } from "../../../../common/fileUpload/fileUpload";
import Preview from '../../registration/preview';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../../common/customDataGridToolbar';
import { Add as AddIcon, Clear as CancelIcon, Cancel as CrossIcon, KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon, CheckCircle as TickIcon, ArrowForwardIosSharp as AccordionIcon, Send as SendIcon, Done as ApproveIcon, Visibility as ViewIcon } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Button, Container, Card, Autocomplete, Divider, CardContent, Radio, RadioGroup, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { PROD } from "../../../../common/constants";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { LocationPointMUI } from '../../../../common/locationPoints/locationPointMUI';
import { useTranslation } from 'react-i18next';
import { FileUploadMUI } from '../../../../common/fileUpload/fileUploadMUI';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { Tooltip, } from '@mui/material';
import { useGrowerForestContextData } from './registrationDetailsForest';
import { CloseIcon, EditIcon, SaveIcon, UpdateIcon } from '../../../../common/icons';
import { insertComment } from '../commonRegistrationStakeholderAPIs';
import { Badge } from 'react-bootstrap';
import apiClient from '../../../../axios';
import CommentIcon from '@mui/icons-material/Comment';

const RangeDetailsForest = () => {
    const { stakeHolderDetails, bambooSpeciesRes, rangeDetailArray, setRangeDetailArray, expandedSection, setExpandedSection, onAddNewFellingDetails, errorMessage, setErrorMessage, setNewBeatComments, setBeatDetailsSectionOk, coupeUpdatedDetails, setCoupeUpdatedDetails, enableFieldFunction, shouldActOnSectionBeat, setShouldActOnSectionBeat, setFellingDetailArray, fellingDetailArray, onaddNewFellingSeriesDetails, onEditFellingDetailsCallback, growerDetails, setCallUpdateApi, newBeatArray, setnewBeatArray, showCommentSection, beatDetailsSectionOk, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, comments, setComments, setCommentsData, viewOnly, usertype } = useGrowerForestContextData();
    const { t } = useTranslation();
    const [characterLimit] = useState(300);
    const navigate = useNavigate();
    const uuid = localStorage.getItem('uuid');
    const { state } = useLocation();
    const [urn, setUrn] = useState(state?.URN);
    const [showAddRangeSection, setShowAddRangeSection] = useState(false);
    const [beatComment, setBeatComment] = useState("");
    const [landAreaValue, setLandAreaValue] = useState();
    const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [captiveStartDateDisplay, setCaptiveStartDateDisplay] = useState();
    const [captiveEndDateDisplay, setCaptiveEndDateDisplay] = useState();
    const [availableCoupes, setAvailableCoupes] = useState([]);
    const [selectedBeats, setselectedBeats] = useState([]);
    const [newBeatObject, setNewBeatObject] = useState([]);
    const [bambooSpecies, setBambooSpecies] = useState();
    const [documentArray, setDocumentArray] = useState([]);
    const [speciesName, setSpeciesName] = useState();
    const [selectedBeat, setSelectedBeat] = useState();
    const [selectedForestBeatOfficerName, setselectedForestBeatOfficerName] = useState();
    console.log("selectedForestBeatOfficerName", selectedForestBeatOfficerName)
    const [selectedBeatId, setSelectedBeatId] = useState();
    const [saveResponse, setSaveResponse] = useState();
    const [open, setOpen] = useState(() => {
        const initialState = {};
        rangeDetailArray.forEach(rangeItem => {
            rangeItem?.growerForestBeatDetails?.forEach(obj => {
                initialState[obj.id] = false;
            });
        })
        return initialState;
    });
    const [hidden, setHidden] = useState({
        divPreview: true
    });

    const commentsColumn = [
        {
            field: 'comment', headerName: t('reg.comments'), width: 330,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'createdByName', headerName: t('preReg.name'), width: 200
        },
        {
            field: 'userRole', headerName: t('reg.userRole'), width: 200
        },
        {
            field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
        },
    ]

    const decoded = jwt(getLocalStorageItem('id_token'));
    let newBeat = {
        boundaryBeatEast: "",
        boundaryBeatWest: "",
        boundaryBangeNorth: "",
        boundaryBeatSouth: "",
        forestBeatOfficeName: "",
        forestBeatOfficerName: "",
        authorizedContactPerson: "",
        address: '',
        pincode: '',
        state: '',
        district: '',
        subDivision: '',
        revenueCircle: '',
        isForestCoupeAvailable: true,
        regForestBeatSeriesCoupeDetails: [],
        regForestBeatLandDetails: []
    }
    let newLand = {
        landName: "",
        postOffice: "",
        captive: true,
        captiveStartDate: '',
        captiveEndDate: '',
        totalNoOfBambooClumps: "",
        isPreregistrationShortlisted: "",
        landLeasedOwned: "",
        leaseStartDate: "",
        leaseEndDate: "",
        easeOfSourcing: "High",
        sidingRequirement: true,
        sidingDistanceInMtrs: "",
        landType: 'Hilly',
        cooperativeName: "",
        cooperativeOwner: "",
        coopLandLocation: "",
        govtAgencyName: "",
        govtAgencyIncharge: "",
        locationGeocode: "",
        geocodeLattitude: "",
        geocodeLongitude: "",
        growerForestBambooSpecies: [],
        growerForestLandDocuments: []
    }
    let newRange = {
        address: '',
        pincode: '',
        state: '',
        district: '',
        subDivision: '',
        revenueCircle: '',
        blockName: '',
        boundaryRangeEast: "",
        boundaryRangeWest: "",
        boundaryRangeNorth: "",
        boundaryRangeSouth: "",
        forestRangeOfficeName: "",
        forestRangeOfficerName: "",
        authorizedContactPerson: "",
        growerForestBeatDetails: []
    }
    const [landDetails, setLandDetails] = useState(newLand);
    const [beatDetails, setBeatDetails] = useState(newBeat);
    const [rangeDetails, setRangeDetails] = useState(newRange);
    const [documentDetailsArr, setDocumentDetailsArr] = useState([]);
    const [documentUploadDetails, setDocumentUploadDetails] = useState();
    let clearRangeMessage = {
        rangeError: '',
        boundaryEastError: '',
        boundaryWestError: '',
        boundarySouthError: '',
        boundaryNorthError: '',
        rangeOfficeNameError: '',
        rangeOfficerError: '',
        rangeAuthorizedContactError: '',
        addressError: '',
        pincodeError: ''

    }
    const [rangeErrorMessage, setRangeErrorMessage] = useState(clearRangeMessage);

    let clearBeatMessage = {
        boundaryEastError: '',
        boundaryWestError: '',
        boundarySouthError: '',
        boundaryNorthError: '',
        beatOfficeNameError: '',
        beatOfficerError: '',
        beatAuthorizedContactError: '',
        addressError: '',
        pincodeError: '',
        submitError: ''
    }
    const [beatErrorMessage, setBeatErrorMessage] = useState(clearBeatMessage);

    let clearLandMessage = {
        addressError: '',
        pincodeError: '',
        stateError: '',
        districtError: '',
        subDivisionError: '',
        revenueCircleError: '',
        captiveError: '',
        captiveStartDateError: '',
        captiveEndDateError: '',
        landAreaError: '',
        landLeasedOwnedError: '',
        leaseStartDateError: '',
        leaseEndDateError: '',
        landTypeError: '',
        easeOfSourcingError: '',
        sidingRequirementError: '',
        sidingDistanceInMtrsError: '',
        growerForestBambooSpeciesError: '',
        mobileNoError: '',
        saveError: '',
        locationDocError: '',
        landdocError: ''
    }
    const [landErrorMessage, setLandErrorMessage] = useState(clearLandMessage);

    const [showRangeSection, setShowRangeSection] = useState(false);
    const [showBeatSection, setShowBeatSection] = useState(false);
    const [showLandSection, setShowLandSection] = useState(false);
    const [showGridSection, setShowGridSection] = useState(true);
    const [captiveStartDate, setStartDatecaptive] = useState();
    const [beatArray, setBeatArray] = useState([]);
    const [landArray, setLandArray] = useState([]);
    const [coupeArray, setCoupeArray] = useState([])
    const [addEditBtnNameLand, setAddEditBtnNameLand] = useState('');
    const [addEditBtnNameBeat, setAddEditBtnNameBeat] = useState('');
    const [addEditBtnNameRange, setAddEditBtnNameRange] = useState('');
    const [selectedRange, setSelectedRange] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [editSpecies, setEditSpecies] = useState();
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
    const [loc, setLoc] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setLoc(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);

    let checkUserDetails = localStorage.getItem('role');
    const addnewRange = (e) => {
        setSelectedRange(null);
        setRangeDetails(newRange);
        setShowAddRangeSection(true);
        setBeatArray([]);
        setAddEditBtnNameRange(t('reg.addRange'));
    }

    const addnewBeat = (item) => {
        const tempId = "noId"
        newBeatObject.length === 0 && setOpen((prevOpen) => ({
            ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
            [tempId]: true
        }));
        setNewBeatObject([
            {
                id: tempId,
                forestBeatOfficeName: "-",
                forestBeatOfficerName: "-",
                authorizedContactPerson: "-",
                forestBeatOfficerName: "-",
                forestRangeOfficeName: item?.forestRangeOfficeName
            }
        ])
        setBeatDetails(newBeat);
        setSelectedBeat(newBeat);
        setSelectedRange(item);
        setselectedForestBeatOfficerName('');
        setSelectedBeatId(uuidv4());
        setAddEditBtnNameBeat(t('reg.addBeat'));
        setLandArray([]);
        setCoupeArray([]);
        setselectedBeats([]);
        var coupes = availableCoupes;
        rangeDetailArray?.forEach((item, index) => {
            item.growerForestBeatDetails?.forEach((item1, index1) => {
                item1.regForestBeatSeriesCoupeDetails?.forEach((item2, index2) => {
                    if (coupes.filter(x => x.coupeID === item2.regForestCoupeId).length > 0) {
                        coupes = coupes.filter(x => x.coupeID !== item2.regForestCoupeId)
                    }
                });

            });
        });
        setAvailableCoupes(coupes);
    }

    const addnewLandBtnClick = (e) => {
        setLandDetails(newLand);
        setCaptiveStartDateDisplay();
        setCaptiveEndDateDisplay();
        setLandAreaUnit("sq ft");
        setLandAreaValue("");
        setShowLandSection(true);
        setShowBeatSection(false);
        setAddEditBtnNameLand(t('reg.addland'));
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
        setLandDetails({ ...landDetails, growerForestLandDocuments: docArray });
    }
    const radioChange = (e, value) => {
        setBeatDetails({ ...beatDetails, [e.target.name]: value })
    };
    const landRadioChange = (e, value) => {
        setLandDetails({ ...landDetails, [e.target.name]: value })
    };
    const bambooSpeciesSubmitCallbackFunction = (bambooSpeciesDetails, onClose) => {
        const remainingArr = bambooSpecies && (landDetails?.growerForestBambooSpecies)?.filter(item => item.bambooSpecies !== bambooSpeciesDetails.bambooSpecies || item.otherBambooSpecies !== bambooSpeciesDetails.otherBambooSpecies);
        remainingArr?.push(bambooSpeciesDetails);
        setLandDetails({ ...landDetails, growerForestBambooSpecies: remainingArr })
        onClose();
    }
    const onDeleteSpecies = (id) => {
        const updatedBambooSpecies = ((landDetails.growerBambooSpecies).map(item => {
            if (item.bambooSpecies === id) {
                item.isActive = 0
            }
            return item
        }
        ))
        setLandDetails({ ...landDetails, growerBambooSpecies: updatedBambooSpecies });
    };

    const getUpdatedAddressData = (data) => {
        setRangeDetails({
            ...rangeDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,

        })
        setRangeErrorMessage({ ...rangeErrorMessage, pincodeError: '' })
    }
    const setBeatAddressData = (data) => {
        setBeatDetails({
            ...beatDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        })
        setBeatErrorMessage({ ...beatErrorMessage, pincodeError: '' })
    }
    const onSubmit = (e) => {
        e.preventDefault();
        handleConfirmLogModalOpen();
    }
    const setLandAddressData = (data) => {
        setLandDetails({
            ...landDetails,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        });
        setLandErrorMessage({ ...landErrorMessage, pincodeError: "" })
    }


    const checkValidations = () => {
        if (!selectedRange && rangeDetailArray?.filter((item, index) => item.forestRangeOfficeName == rangeDetails.forestRangeOfficeName).length > 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, rangeError: "Range with the same name already exists" })
        }
        else if (validateRangeDetails()) {
            onRangeSubmit();
        }
    }
    const onDeleteLand = (beatItem, landItem) => {
        const tempArr = (landArray?.map(item => {
            if (item.landName === landItem.landName) {
                item.isActive = 0
            }
            return item
        }
        ))
        setLandArray(tempArr);
        setBeatDetails({ ...beatDetails, regForestBeatLandDetails: tempArr });
    };
    const handleRangeChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setRangeDetails({ ...rangeDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setRangeDetails({ ...rangeDetails, revenueCircle: e.target.value, });
        }
    }
    const handleBeatChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setBeatDetails({ ...beatDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setBeatDetails({ ...beatDetails, revenueCircle: e.target.value, });
        }
    }
    const handleLandChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setLandDetails({ ...landDetails, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setLandDetails({ ...landDetails, revenueCircle: e.target.value, });
        }
    }
    const validateRangeDetails = () => {

        if (!rangeDetails?.boundaryRangeEast || rangeDetails?.boundaryRangeEast.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, boundaryEastError: "Please enter east boundary" })
            return false;
        }
        else if (!rangeDetails?.boundaryRangeWest || rangeDetails?.boundaryRangeWest.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, boundaryWestError: "Please enter west boundary" })
            return false;
        }
        else if (!rangeDetails?.boundaryRangeNorth || rangeDetails?.boundaryRangeNorth.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, boundaryNorthError: "Please enter north boundary" })
            return false;
        }
        else if (!rangeDetails?.boundaryRangeSouth || rangeDetails?.boundaryRangeSouth.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, boundarySouthError: "Please enter north boundary" })
            return false;
        }
        else if (!rangeDetails?.forestRangeOfficeName || rangeDetails?.forestRangeOfficeName.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficeNameError: "Please enter forest range office name" })
            return false;
        }
        else if (!rangeDetails?.forestRangeOfficerName || rangeDetails?.forestRangeOfficerName.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficerError: "Please enter forest range officer name" })
            return false;
        }
        else if (!rangeDetails?.authorizedContactPerson || rangeDetails?.authorizedContactPerson.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, rangeAuthorizedContactError: "Please enter authorized contact number" })
            return false;
        }
        else if (!rangeDetails?.address || rangeDetails?.address.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, addressError: "Please enter address" })
            return false;
        }
        else if (!rangeDetails?.pincode || rangeDetails?.pincode.length == 0) {
            setRangeErrorMessage({ ...rangeErrorMessage, pincodeError: "Please enter pincode" })
            return false;
        }
        return true;
    }
    const validateBeatDetails = () => {
        if (!beatDetails?.boundaryBeatEast || beatDetails?.boundaryBeatEast.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, boundaryEastError: "Please enter east boundary" })
            return false;
        }
        else if (!beatDetails?.boundaryBeatWest || beatDetails?.boundaryBeatWest.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, boundaryWestError: "Please enter west boundary" })
            return false;
        }
        else if (!beatDetails?.boundaryBeatNorth || beatDetails?.boundaryBeatNorth.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, boundaryNorthError: "Please enter north boundary" })
            return false;
        }
        else if (!beatDetails?.boundaryBeatSouth || beatDetails?.boundaryBeatSouth.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, boundarySouthError: "Please enter north boundary" })
            return false;
        }
        else if (!beatDetails?.forestBeatOfficeName || beatDetails?.forestBeatOfficeName.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, beatOfficeNameError: "Please enter forest beat office name" })
            return false;
        }
        else if (!beatDetails?.forestBeatOfficerName || beatDetails?.forestBeatOfficerName.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, beatOfficerError: "Please enter forest beat officer name" })
            return false;
        }
        else if (!beatDetails?.authorizedContactPerson || beatDetails?.authorizedContactPerson.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, beatAuthorizedContactError: "Please enter authorized contact number" })
            return false;
        }
        else if (!beatDetails?.address || beatDetails?.address.length == 0) {
            setBeatErrorMessage({ ...beatErrorMessage, addressError: "Please enter address" })
            return false;
        }
        else if (!beatDetails?.pincode || beatDetails?.pincode.length != 6) {
            setBeatErrorMessage({ ...beatErrorMessage, pincodeError: "Please enter valid pincode" })
            return false;
        }
        else if (!beatDetails.isForestCoupeAvailable && (!landArray || landArray.length == 0)) {
            setBeatErrorMessage({ ...beatErrorMessage, submitError: "Please add land details" })
            return false;
        }
        else if (beatDetails.isForestCoupeAvailable && (!beatDetails?.regForestBeatSeriesCoupeDetails || beatDetails?.regForestBeatSeriesCoupeDetails.length == 0)) {
            setBeatErrorMessage({ ...beatErrorMessage, submitError: "Please add coupe details" })
            return false;
        }
        else {
            setBeatErrorMessage({ ...beatErrorMessage, submitError: "" })
        }
        return true;
    }
    const validateLandDetails = () => {
        if (!landDetails?.address || landDetails?.address.length == 0) {
            setLandErrorMessage({ ...landErrorMessage, addressError: "Please enter land address" })
            return false;
        }
        else if (!landDetails?.pincode || landDetails?.pincode.length == 0) {
            setLandErrorMessage({ ...landErrorMessage, pincodeError: "Please enter pincode" })
            return false;
        }
        // else if (landDetails.captive && !landDetails.captiveStartDate) {
        //     setLandErrorMessage({ ...landErrorMessage, captiveStartDateError: "Please enter captive start date" })
        //     return false;
        // }
        // else if (landDetails.captive && !landDetails.captiveEndDate) {
        //     setLandErrorMessage({ ...landErrorMessage, captiveEndDateError: "Please enter captive end date" })
        //     return false;
        // }
        else if (landDetails.captive && landDetails.captiveEndDate < landDetails.captiveStartDate) {
            setLandErrorMessage({ ...landErrorMessage, captiveEndDateError: "captive end date should be greater than captive start date" })
            return false;
        }
        else if (!landAreaValue) {
            setLandErrorMessage({ ...landErrorMessage, landAreaError: "Please enter land area" })
            return false;
        }
        else if (!landDetails?.landName || landDetails?.landName.length == 0) {
            setLandErrorMessage({ ...landErrorMessage, landNameError: "Please enter land name" })
            return false;
        }
        else if (landDetails?.sidingRequirement && !landDetails?.sidingDistanceInMtrs) {
            setLandErrorMessage({ ...landErrorMessage, sidingDistanceInMtrsError: "Please enter siding distance" })
            return false;
        }
        else if (!landDetails?.geocodeLattitude) {
            setErrorMessage({ latitudesError: "Please enter latitude" })
            return false;
        }
        else if (!landDetails?.geocodeLongitude) {
            setErrorMessage({ longitudesError: "Please enter longitude" })
            return false;
        }
        var locationDoc = documentArray && documentArray.filter((item) => item.documentType === "LandPics" && item.isActive == 1);
        if (locationDoc.length == 0) {
            setLandErrorMessage({ ...landErrorMessage, locationDocError: "Please upload landPic" });
            return false;
        }
        var landDoc = documentArray && documentArray.filter((item) => item.documentType === LAND_DOCUMENT && item.isActive == 1);
        if (landDoc.length == 0) {
            setLandErrorMessage({ ...landErrorMessage, landdocError: "Please upload land document" });
            return false;
        }
        return true;
    }
    const onRangeSubmit = () => {
        setRangeErrorMessage(clearRangeMessage);
        setShowGridSection(true);
        setShowRangeSection(false);
        const remainingArr = rangeDetailArray?.filter((item, index) => item.forestRangeOfficeName !== rangeDetails.forestRangeOfficeName);
        let addRangeObject = {
            id: rangeDetails.id,
            boundaryRangeEast: rangeDetails.boundaryRangeEast,
            boundaryRangeWest: rangeDetails.boundaryRangeWest,
            boundaryRangeNorth: rangeDetails.boundaryRangeNorth,
            boundaryRangeSouth: rangeDetails.boundaryRangeSouth,
            forestRangeOfficeName: rangeDetails.forestRangeOfficeName,
            forestRangeOfficerName: rangeDetails.forestRangeOfficerName,
            authorizedContactPerson: rangeDetails.authorizedContactPerson,
            isActive: 1,
            address: rangeDetails.address,
            pincode: rangeDetails.pincode,
            state: rangeDetails.state,
            district: rangeDetails.district,
            subDivision: rangeDetails.subDivision,
            revenueCircle: rangeDetails.revenueCircle,
            blockName: rangeDetails.blockName,
            createdOn: rangeDetails.createdOn,
            createdBy: rangeDetails.createdBy,
            updatedOn: rangeDetails.updatedOn,
            updatedBy: rangeDetails.updatedBy,
            growerForestBeatDetails: []
        }
        remainingArr.push(addRangeObject);
        setShowAddRangeSection(false);
        setRangeDetailArray(remainingArr);
    }
    const onCancel = (e) => {
        setRangeErrorMessage(clearRangeMessage);
        setBeatErrorMessage(clearBeatMessage);
        setNewBeatObject([]);
        setShowAddRangeSection(false);
    }
    const onLandCancel = (e) => {
        setLandErrorMessage(clearLandMessage);
        setShowRangeSection(false);
        setShowGridSection(false);
        setShowBeatSection(true);
        setAddEditBtnNameBeat(beatDetails.id ? t('reg.updateBeat') : t('reg.addBeat'));
        setShowLandSection(false);
    }

    const onBeatSubmit = () => {
        setBeatErrorMessage(clearBeatMessage);
        if (selectedRange && selectedRange.growerForestBeatDetails?.filter((item, index) => item.forestBeatOfficeName == beatDetails.forestBeatOfficeName).length > 0 && addEditBtnNameBeat !== "Update Beat") {
            setBeatErrorMessage({ ...beatErrorMessage, submitError: "Beat with the same name already exists" })
            return;
        }
        if (validateBeatDetails()) {
            const data =
            {
                boundaryBeatEast: beatDetails.boundaryBeatEast,
                boundaryBeatWest: beatDetails.boundaryBeatWest,
                boundaryBeatNorth: beatDetails.boundaryBeatNorth,
                boundaryBeatSouth: beatDetails.boundaryBeatSouth,
                forestBeatOfficeName: beatDetails.forestBeatOfficeName,
                forestBeatOfficerName: beatDetails.forestBeatOfficerName,
                authorizedContactPerson: beatDetails.authorizedContactPerson,
                isActive: 1,
                address: beatDetails.address,
                pincode: beatDetails.pincode,
                state: beatDetails.state,
                district: beatDetails.district,
                subDivision: beatDetails.subDivision,
                revenueCircle: beatDetails.revenueCircle,
                blockName: beatDetails.blockName,
                regForestBeatLandDetails: landArray,
                regForestBeatSeriesCoupeDetails: beatDetails.regForestBeatSeriesCoupeDetails,
                createdOn: beatDetails.createdOn,
                createdBy: beatDetails.createdBy,
                updatedOn: beatDetails.updatedOn,
                updatedBy: beatDetails.updatedBy,
                id: beatDetails.id,
                isForestCoupeAvailable: beatDetails.isForestCoupeAvailable
            }
            const remainingArr = beatArray?.filter(obj => obj?.forestBeatOfficeName !== beatDetails?.forestBeatOfficeName)
            remainingArr?.push(data)
            setBeatArray(remainingArr)
            var range = selectedRange;
            range.growerForestBeatDetails = remainingArr;
            setSelectedRange({ ...selectedRange, growerForestBeatDetails: remainingArr })

            const remainingrangeDetailArray = rangeDetailArray?.filter(obj => obj?.forestRangeOfficeName !== selectedRange?.forestRangeOfficeName);
            remainingrangeDetailArray.push(range);
            setNewBeatObject([])
            setRangeDetailArray(remainingrangeDetailArray);
            setShowGridSection(true);
            setShowBeatSection(false);
        }
    }

    const onLandSubmit = () => {
        setLandErrorMessage(clearLandMessage);
        if (selectedBeat && selectedBeat.regForestBeatLandDetails?.filter((item, index) => item.landName == landDetails.landName).length > 0) {
            setLandErrorMessage({ ...landErrorMessage, saveError: "Land with the same name already exists" })
            return;
        }
        if (validateLandDetails()) {
            const data =
            {
                id: landDetails.id,
                landName: landDetails.landName,
                address: landDetails.address,
                pincode: landDetails.pincode,
                state: landDetails.state,
                district: landDetails.district,
                subDivision: landDetails.subDivision,
                postOffice: landDetails.postOffice,
                revenueCircle: landDetails.revenueCircle,
                blockName: landDetails.blockName,
                captive: true,
                captiveStartDate: landDetails.captiveStartDate,
                captiveEndDate: landDetails.captiveEndDate,
                landArea: landDetails.landArea,
                totalNoOfBambooClumps: landDetails.totalNoOfBambooClumps,
                isPreregistrationShortlisted: true,
                landLeasedOwned: landDetails.landLeasedOwned,
                leaseStartDate: landDetails.leaseStartDate,
                leaseEndDate: landDetails.leaseEndDate,
                easeOfSourcing: landDetails.easeOfSourcing ? landDetails.easeOfSourcing : "High",
                sidingRequirement: landDetails.sidingRequirement,
                sidingDistanceInMtrs: landDetails.sidingDistanceInMtrs,
                landType: landDetails.landType,
                cooperativeName: landDetails.cooperativeName,
                cooperativeOwner: landDetails.cooperativeOwner,
                coopLandLocation: landDetails.coopLandLocation,
                govtAgencyName: landDetails.govtAgencyName,
                govtAgencyIncharge: landDetails.govtAgencyIncharge,
                locationGeocode: landDetails.locationGeocode,
                geocodeLattitude: landDetails.geocodeLattitude,
                geocodeLongitude: landDetails.geocodeLongitude,
                createdOn: landDetails.createdOn,
                createdBy: landDetails.createdBy,
                updatedOn: landDetails.updatedOn,
                updatedBy: landDetails.updatedBy,
                growerForestBambooSpecies: landDetails.growerForestBambooSpecies,
                growerForestLandDocuments: landDetails.growerForestLandDocuments,
                isActive: 1,
            }
            const remainingArr = landArray?.filter(obj => obj?.landName !== landDetails?.landName)
            remainingArr.push(data)
            setLandArray(remainingArr)
            setSelectedBeat({ ...selectedBeat, regForestBeatLandDetails: remainingArr });
            setShowBeatSection(true);
            setShowLandSection(false);
            setAddEditBtnNameBeat(beatDetails.id ? t('reg.updateBeat') : t('reg.addBeat'));
        }
    }
    const OnPreviousSubmit = () => {
        navigate("/dashboardHome/personalDetailsForest", { state: { URN: state?.URN } })
    }

    useEffect(() => {
        if (saveResponse) {
            if (saveResponse?.isSuccess) {
                toast.success(saveResponse?.message)
            }
            else toast.error(saveResponse?.message)

        }
    }, [saveResponse]);

    const onDeleteRangeDetails = (selectedMember) => {
        const tempArr = (rangeDetailArray?.map(item => {
            if (item?.id === selectedMember.id) {
                item.isActive = 0
            }
            return item;
        }
        ))
        setRangeDetailArray(tempArr);
    }

    const onDeleteBeatDetails = (selectedRange, selectedMember) => {
        const tempArr = (selectedRange?.growerForestBeatDetails?.map(item => {
            if (item?.id === selectedMember.id) {
                item.isActive = 0
            }
            return item;
        }
        ))
        setBeatArray(tempArr);
    }
    const onDeleteCoupeDetails = (selectedItem) => {
        const tempArr = (beatDetails.regForestBeatSeriesCoupeDetails?.map(item => {
            if (item?.regForestCoupeId === selectedItem.regForestCoupeId) {
                item.isActive = 0
            }
            return item;
        }
        ))
        setBeatDetails({ ...beatDetails, regForestBeatSeriesCoupeDetails: tempArr });
    }

    const onSaveComment = (comment) => {
        const newBeatArrayTemp = selectedRange?.growerForestBeatDetails
        const commentObject = {
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "beat_details",
            sectionId: selectedBeatId,
            sectionOk: beatDetailsSectionOk[selectedBeatId],
            userRole: localStorage.getItem('role'),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
        }
        const newbeatCommentObject = {
            id: uuidv4(),
            comment: comment,
            stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
            sectionName: "beat_details",
            sectionId: selectedBeatId,
            sectionOk: beatDetailsSectionOk[selectedBeatId],
            userRole: localStorage.getItem('role'),
            type: "New Beat",
            forestBeatOfficerName: !selectedForestBeatOfficerName ? beatDetails.forestBeatOfficeName : newBeatArrayTemp.find((item) => item.id === selectedBeatId),
            createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
            createdByName: comments?.find((item) => item.sectionName === "beat_details")?.createdByName,
            createdOnFormatted: moment(new Date()).format("DD-MM-YYYY hh:mm a"),
            workflowStepDetailsId: null
        }
        if (comment) {
            if (!selectedForestBeatOfficerName) {
                const tempArr = [...comments]
                tempArr.push(newbeatCommentObject)
                setComments(tempArr);
            }
            else insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData)
        }
        else toast.error("Please enter comment");
        setBeatComment("")
        setErrorMessage({ ...errorMessage, beatCommentError: "" });

    }

    const handleDateChange = (e, name) => {
        e.preventDefault();
        let date = e.target.value;
        let formattedDate = moment(date).format(API_DATE_FORMAT)
        setLandDetails({ ...landDetails, [name]: formattedDate })
        if (name == "captiveStartDate")
            setCaptiveStartDateDisplay(date);
        else if (name == "captiveEndDate")
            setCaptiveEndDateDisplay(date);
        if (landDetails.captive && landDetails.captiveEndDate < landDetails.captiveStartDate) {
            setErrorMessage({ captiveEndDateError: "captive end date should be greater than captive start date" })
        }
        else
            setErrorMessage({ captiveEndDateError: "" })
    }
    function getGrowerBambooSpecies() {
        loaderService.showLoader();
        apiClient
            .post(GET_GROWER_BAMBOO_SPECIES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setBambooSpecies(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    function getAvailableCoupes() {
        loaderService.showLoader();
        apiClient
            .post(GET_AVAILABLE_COUPES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setAvailableCoupes(response.data.coupes);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    useEffect(() => {
        getGrowerBambooSpecies();
        getAvailableCoupes();
    }, []);

    const onhandleChange = (e) => {
        if (e.target.name === "boundaryRangeEast") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, boundaryEastError: "" })
            } else setRangeErrorMessage({ ...rangeErrorMessage, boundaryEastError: "Please enter east boundary" })
        }
        else if (e.target.name === "boundaryRangeWest") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, boundaryWestError: "" })
            }
            else {
                setRangeErrorMessage({ ...rangeErrorMessage, boundaryWestError: "Please enter west boundary" })
            }
        }
        else if (e.target.name === "boundaryRangeNorth") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, boundaryNorthError: "" })
            }
            else {
                setRangeErrorMessage({ ...rangeErrorMessage, boundaryNorthError: "Please enter north boundary" })
            }
        }
        else if (e.target.name === "boundaryRangeSouth") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, boundarySouthError: "" })
            }
            else {
                setRangeErrorMessage({ ...rangeErrorMessage, boundarySouthError: "Please enter north boundary" })
            }
        }
        else if (e.target.name === "forestRangeOfficeName") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficeNameError: "" })
            }
            else {
                setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficeNameError: "Please enter forest range office name" })
            }
        }
        else if (e.target.name === "forestRangeOfficerName") {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficerError: "" })
            }
            else {
                setRangeErrorMessage({ ...rangeErrorMessage, rangeOfficerError: "Please enter forest range office name" })
            }
        }
        else if (e.target.name === "authorizedContactPerson") {
            var slicedMobileNumber = mobileNumberValidation(e.target.value);
            setRangeDetails({ ...rangeDetails, [e.target.name]: slicedMobileNumber })
            if (slicedMobileNumber.length != 10) {
                setRangeErrorMessage({ ...rangeErrorMessage, rangeAuthorizedContactError: MOBILE_NO_ERROR });
            }
            else setRangeErrorMessage({ ...rangeErrorMessage, rangeAuthorizedContactError: "" });

        }
        else if (e.target.name === "pincode") {
            if (e.target.value.length !== 6) {
                setRangeDetails({ ...rangeDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setRangeErrorMessage({ ...rangeErrorMessage, pincodeError: PINCODE_NO_ERROR });
            } else setRangeErrorMessage({ ...rangeErrorMessage, pincodeError: "" });
        }
        else if (e.target.name === 'address') {
            setRangeDetails({ ...rangeDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) })
            if (e.target.value.length > 0) {
                setRangeErrorMessage({ ...rangeErrorMessage, addressError: "" });
            } else setRangeErrorMessage({ ...rangeErrorMessage, addressError: EMPTY_FIELD_ERROR });
        }
        else {

            setRangeDetails({ ...rangeDetails, [e.target.name]: (e.target.value) })
        }
    }
    const handleLandChange = (e) => {
        setLandDetails({ ...landDetails, [e.target.name]: e.target.value })
        if (e.target.name === "pincode") {
            if (e.target.value.length !== 6) {
                setLandDetails({ ...landDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setLandErrorMessage({ ...landErrorMessage, pincodeError: PINCODE_NO_ERROR });
            } else setLandErrorMessage({ ...landErrorMessage, pincodeError: "" });
        }
        else if (e.target.name === 'address') {
            if (e.target.value.length > 0) {
                setLandErrorMessage({ ...landErrorMessage, addressError: "" });
                setLandDetails({ ...landDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) })
            } else setLandErrorMessage({ ...landErrorMessage, addressError: EMPTY_FIELD_ERROR });
        }
        else if (e.target.name === "landAreaValue") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setLandAreaValue(slicedLandArea);
            if (slicedLandArea.length == 0) {
                setLandErrorMessage({ ...landErrorMessage, landAreaError: LAND_AREA_ERROR });
            }
            else setLandErrorMessage({ ...landErrorMessage, landAreaError: "" });
            setLandDetails({ ...landDetails, "landArea": slicedLandArea + ' ' + landAreaUnit });
        }
        else if (e.target.name === "landAreaUnit") {
            setLandAreaUnit(e.target.value);
            setLandDetails({ ...landDetails, "landArea": landAreaValue + ' ' + e.target.value });
        }
        else if (e.target.name === "sidingDistanceInMtrs") {
            var slicedDistance = e.target.value.slice(0, 10);
            setLandDetails({ ...landDetails, [e.target.name]: slicedDistance })
            if (slicedDistance.length == 0) {
                setLandErrorMessage({ ...landErrorMessage, sidingDistanceInMtrsError: "Please enter siding distance" });
            }
            else setLandErrorMessage({ ...landErrorMessage, sidingDistanceInMtrsError: "" });
        }

        else if (e.target.name === "landName") {
            var slicedLandName = VALIDATION.fullNameValidation(e.target.value).slice(0, 20);
            setLandDetails({ ...landDetails, [e.target.name]: slicedLandName })
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setLandErrorMessage({ ...landErrorMessage, landNameError: "" });
            }
            else
                setLandErrorMessage({ ...landErrorMessage, landNameError: "Please enter land name" });
        }
    };
    const handleBeatChange = (e) => {
        setBeatDetails({ ...beatDetails, [e.target.name]: e.target.value })
        if (e.target.name === "boundaryBeatEast") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryEastError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryEastError: "Please enter east boundary" })
            }
        }
        else if (e.target.name === "boundaryBeatWest") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryWestError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryWestError: "Please enter west boundary" })
            }
        }
        else if (e.target.name === "boundaryBeatNorth") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryNorthError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, boundaryNorthError: "Please enter north boundary" })
            }
        }
        else if (e.target.name === "boundaryBeatSouth") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, boundarySouthError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, boundarySouthError: "Please enter north boundary" })
            }
        }
        else if (e.target.name === "forestBeatOfficeName") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, beatOfficeNameError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, beatOfficeNameError: "Please enter forest beat office name" })
            }
        }
        else if (e.target.name === "forestBeatOfficerName") {
            setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) })
            if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setBeatErrorMessage({ ...beatErrorMessage, beatOfficerError: "" })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, beatOfficerError: "Please enter forest beat officer name" })
            }
        }
        else if (e.target.name === "authorizedContactPerson") {
            var slicedMobileNumber = mobileNumberValidation(e.target.value);
            setBeatDetails({ ...beatDetails, authorizedContactPerson: slicedMobileNumber })
            if (slicedMobileNumber.length != 10) {
                setBeatErrorMessage({ ...beatErrorMessage, beatAuthorizedContactError: 'Please enter a valid mobile number' })
            }
            else {
                setBeatErrorMessage({ ...beatErrorMessage, beatAuthorizedContactError: "" })
            }

        }
        else if (e.target.name === "pincode") {
            if (e.target.value.length !== 6) {
                setBeatDetails({ ...beatDetails, [e.target.name]: pincodeValidation(e.target.value) })
                setBeatErrorMessage({ ...beatErrorMessage, pincodeError: PINCODE_NO_ERROR });
            } else setBeatErrorMessage({ ...beatErrorMessage, pincodeError: "" });
        }
        else if (e.target.name === 'address') {
            if (e.target.value.length > 0) {
                setBeatErrorMessage({ ...beatErrorMessage, addressError: "" });
                setBeatDetails({ ...beatDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) })
            } else setBeatErrorMessage({ ...beatErrorMessage, addressError: EMPTY_FIELD_ERROR });
        }
    };
    const addBamboo = (e, selectedSpecies, otherSpeciesName) => {
        setEditSpecies(selectedSpecies)
        setSpeciesName(otherSpeciesName)
        handleLogModalOpen();
    }
    const validateSave = () => {
        var isValidated = true;
        if (rangeDetailArray.length == 0) {
            isValidated = false;
        }
        rangeDetailArray?.forEach((item, index) => {
            if (item.isActive && (!item.growerForestBeatDetails || item.growerForestBeatDetails.length == 0)) {
                isValidated = false;
            }
        });
        return isValidated;
    }

    const onEditRangeDetails = (e, item, index) => {
        setAddEditBtnNameRange(t('reg.updateRange'));
        let range = rangeDetailArray && rangeDetailArray?.filter(obj => obj?.forestRangeOfficeName === item?.forestRangeOfficeName)[0];
        setSelectedRange(range);
        setShowAddRangeSection(true);
        setRangeDetails({
            ...rangeDetails,
            id: range.id,
            boundaryRangeEast: range.boundaryRangeEast,
            boundaryRangeWest: range.boundaryRangeWest,
            boundaryRangeNorth: range.boundaryRangeNorth,
            boundaryRangeSouth: range.boundaryRangeSouth,
            forestRangeOfficeName: range.forestRangeOfficeName,
            forestRangeOfficerName: range.forestRangeOfficerName,
            authorizedContactPerson: range.authorizedContactPerson,
            address: range.address,
            pincode: range.pincode,
            state: range.state,
            district: range.district,
            subDivision: range.subDivision,
            revenueCircle: range.revenueCircle,
            blockName: range.blockName,
            createdOn: range.createdOn,
            createdBy: range.createdBy,
            updatedOn: range.updatedOn,
            updatedBy: range.updatedBy,
        });
    }
    const editBeatDetails = (rangeItem, beatItem) => {
        setSelectedRange(rangeItem);
        setSelectedBeat(beatItem);
        setselectedForestBeatOfficerName(beatItem.forestBeatOfficerName);
        setSelectedBeatId(beatItem.id);
        setBeatDetails(beatItem);
        setLandArray(beatItem.regForestBeatLandDetails);
        setCoupeArray(beatItem.regForestBeatSeriesCoupeDetails);
        setShowGridSection(false);
        setShowBeatSection(true);
        setShowLandSection(false);
        setAddEditBtnNameBeat(t('reg.updateBeat'));

    }
    const editLandDetails = (e, landItem) => {
        setLandDetails(landItem);
        setLandAreaUnit(landItem.landArea?.split(" ")[1]);
        setLandAreaValue(landItem.landArea?.split(" ")[0]);
        setDocumentArray(landItem.growerForestLandDocuments);
        setCaptiveStartDateDisplay(landItem.captiveStartDate && moment(landItem.captiveStartDate).format(BASIC_DATE_FORMAT))
        setCaptiveEndDateDisplay(landItem.captiveEndDate && moment(landItem.captiveEndDate).format(BASIC_DATE_FORMAT))
        setShowGridSection(false);
        setShowBeatSection(false);
        setSelectedBeatId(landItem.id)
        setShowLandSection(true);
        setAddEditBtnNameLand(t('reg.updateLand'));
    }
    const onCoupeRemoved = (selectedList, selectedItem) => {
        var coupes = selectedBeats;
        var arr = selectedBeats.filter(item => item.coupeID != selectedItem.coupeID);
        setselectedBeats(arr);
    }

    const onLocationPoint = (position) => {
        setLandDetails({
            ...landDetails,
            geocodeLattitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
            geocodeLongitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
        });
    }

    const onCoupeAdded = (e, value) => {
        setselectedBeats(value);
    }

    const onAddCoupe = (e) => {
        e.preventDefault();
        var arr = beatDetails?.regForestBeatSeriesCoupeDetails;
        for (var i = 0; i < selectedBeats.length; i++) {
            var coupeDetails = {
                regForestBeatId: selectedBeat?.id,
                regForestSeriesId: selectedBeats[i].fellingSeriesID,
                regForestCoupeId: selectedBeats[i].coupeID,
                regForestSeries: {
                    fellingSeriesName: selectedBeats[i].fellignSeriesName,
                },
                regForestCoupe: {
                    coupeName: selectedBeats[i].coupeName,
                },
                isActive: 1
            }
            arr = arr.filter((item) => item.regForestCoupeId !== selectedBeats[i].coupeID);
            arr.push(coupeDetails);

        }
        setBeatDetails({ ...beatDetails, regForestBeatSeriesCoupeDetails: arr });
    }

    const beatColumns = [
        {
            field: 'forestBeatOfficeName',
            headerName: t('reg.forestBeatOffice'),
            width: 200
        },
        {
            field: 'forestBeatOfficerName',
            headerName: t('reg.forestBeatOfficer'),
            width: 200
        },
        {
            field: 'authorizedContactPerson',
            headerName: t('reg.authorizedContactNo'),
            width: 250
        },
        {
            field: 'view',
            headerName: t('reg.actions'),
            type: 'action',
            width: 200,
            renderCell: (params) => {
                return (
                    <>
                        {/* <Button onClick={(e) => editBeatDetails(e, params.row.parent, params.row)} disabled={isDisabledRegOnly()}>{t('reg.edit')}</Button>
                        <IconButton size='small' color="error" aria-label="search"
                            onClick={() => onDeleteBeatDetails(params.row)} disabled={isDisabledRegOnly()} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton> */}
                    </>
                )
            }
        },
    ]

    const coupeFellingColumns = [
        {
            field: 'coupeName',
            headerName: 'Coupe Name',
            valueGetter: (params) => { return params?.row?.regForestCoupe?.coupeName },
            width: 200
        },
        {
            field: 'fellingSeriesName',
            headerName: 'Felling Series Name',
            valueGetter: (params) => { return params?.row?.regForestSeries?.fellingSeriesName },
            width: 200
        },
        {
            field: 'view',
            headerName: 'Delete',
            type: 'action',
            width: 200,
            renderCell: (params) => {
                return (
                    <>
                        <IconButton disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)} size='small' color="error" aria-label="search"
                            onClick={() => onDeleteCoupeDetails(params.row)} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton>
                    </>
                )
            }
        },
    ]

    const landColumns = [
        {
            field: 'pincode',
            headerName: t('preReg.pincode'),
            width: 90
        },
        {
            field: 'landName',
            headerName: t('reg.landName'),
            width: 120
        },
        {
            field: 'landType',
            headerName: t('reg.landType'),
            width: 100
        },
        {
            field: 'bamboo quantity',
            headerName: t('reg.totalBambooQuantity'),
            width: 200,
            renderCell: params => params.row?.growerForestBambooSpecies.reduce((a, v) => a = a + ((v.noOfClumps * v.avgClumpSize * v.avgPoleWeight) / 1000), 0)
        },
        {
            field: 'commited quantity',
            headerName: t('reg.committedQuantity'),
            width: 200,
            renderCell: params => params.row?.growerForestBambooSpecies.reduce((a, v) => a = a + ((v.committedNoOfClumps * 1)), 0)
        },
        {
            field: 'actions',
            headerName: t('reg.actions'),
            type: 'action',
            width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {/* <Button onClick={(e) => editLandDetails(e, params.row)} disabled={isDisabledRegOnly()}>{t('reg.edit')}</Button>
                        <IconButton size='small' color="error" aria-label="search"
                            onClick={() => onDeleteLand(params.row.parent, params.row)} disabled={isDisabledRegOnly()} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton> */}
                    </>
                )
            }
        },
    ]

    const columns = [
        {
            field: 'speciesType',
            headerName: t('reg.speciesType'),
            width: 130,
            renderCell: params => (bambooSpecies?.filter(a => a.id === params.row.bambooSpecies)[0].value) + (params.row.otherBambooSpecies ? " - " + params.row.otherBambooSpecies : "")
        },
        {
            field: 'noOfClumps',
            headerName: t('reg.noOfClumps'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgClumpSize',
            headerName: t('reg.avgClumpSize'),
            width: 130,
            type: "number"
        },
        {
            field: 'avgPoleWeight',
            headerName: t('reg.avgWeightOfBambooPole'),
            width: 170,
            type: "number"
        },
        //{
        //    field: 'otherBambooSpecies',
        //    headerName: t('reg.speciesName'),
        //    width: 130
        //},
        {
            field: 'totalQuantity',
            headerName: t('reg.totalBambooQuantity'),
            width: 250,
            type: "number",
            renderCell: params => (params.row.noOfClumps * params.row.avgClumpSize * params.row.avgPoleWeight) / 1000
        },
        {
            field: 'committedNoOfClumps',
            headerName: t('reg.committedQuantity'),
            width: 250
        },
        {
            field: 'actions',
            headerName: t('reg.actions'),
            type: 'action',
            width: 100,
            renderCell: (params) => {
                return (
                    <>
                        <Button onClick={(e) => addBamboo(e, bambooSpecies?.filter(a => a.id === params.row.bambooSpecies)[0].value, params.row.otherBambooSpecies)}>{t('reg.edit')}</Button>
                        <IconButton size='small' color="error"
                            onClick={() => onDeleteSpecies(params.row.bambooSpecies, params.row.otherBambooSpecies)} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton>
                    </>
                )
            }
        },

    ]

    return (
        <Grid item xs={12}>
            <Accordion mt={1} expanded={expandedSection === "range"}
                onChange={(event, expanded) => {
                    setExpandedSection(expanded ? "range" : "");
                }}>
                <AccordionSummary sx={{
                    flexDirection: 'row-reverse',
                    backgroundColor: showCommentSection ? (Object.values(beatDetailsSectionOk).every(value => value === true) && Object.values(beatDetailsSectionOk).length > 0 ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                }}
                    expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                    <Stack ml={2} display="flex" alignItems="center" direction="row">
                        {showCommentSection && (Object.values(beatDetailsSectionOk).every(value => value === true) && Object.values(beatDetailsSectionOk).length > 0 ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                        <Typography variant="subtitle1" >Range Details</Typography>
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>

                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                            {
                                !showWorkFlowButtons && !showClarificationButton &&
                                <Button onClick={(e) => addnewRange(e)}
                                    disabled={!enableSaveSubmitButtons || viewOnly}
                                    variant="contained" startIcon={<AddIcon />}>
                                    {t('reg.addNewRange')}
                                </Button>}
                        </Stack>
                    </Stack>
                    {showAddRangeSection &&
                        <Grid container spacing={2}>
                            <Grid item xs={4} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.boundaryEastError}
                                            helperText={rangeErrorMessage.boundaryEastError}
                                            type="text"
                                            name="boundaryRangeEast"
                                            value={rangeDetails.boundaryRangeEast}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.boundaryEast')}
                                            inputProps={{
                                                style: { textTransform: "capitalize" }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.boundaryWestError}
                                            helperText={rangeErrorMessage.boundaryWestError}
                                            type="text"
                                            name="boundaryRangeWest"
                                            value={rangeDetails.boundaryRangeWest}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.boundaryWest')}

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.boundaryNorthError}
                                            helperText={rangeErrorMessage.boundaryNorthError}
                                            type="text"
                                            name="boundaryRangeNorth"
                                            value={rangeDetails.boundaryRangeNorth}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.boundaryNorth')}

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.boundarySouthError}
                                            helperText={rangeErrorMessage.boundarySouthError}
                                            type="text"
                                            name="boundaryRangeSouth"
                                            value={rangeDetails.boundaryRangeSouth}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.boundarySouth')}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            disabled={addEditBtnNameRange === "Update Range"}
                                            error={rangeErrorMessage.rangeOfficeNameError}
                                            helperText={rangeErrorMessage.rangeOfficeNameError}
                                            type="text"
                                            name="forestRangeOfficeName"
                                            value={rangeDetails.forestRangeOfficeName}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.forestRangeOffice')}

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.rangeOfficerError}
                                            helperText={rangeErrorMessage.rangeOfficerError}
                                            type="text"
                                            name="forestRangeOfficerName"
                                            value={rangeDetails.forestRangeOfficerName}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.forestRangeOfficer')}

                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={rangeErrorMessage.rangeAuthorizedContactError}
                                            helperText={rangeErrorMessage.rangeAuthorizedContactError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="authorizedContactPerson"
                                            value={rangeDetails.authorizedContactPerson}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.authorizedContactNo')}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            multiline
                                            error={rangeErrorMessage.addressError}
                                            helperText={rangeErrorMessage.addressError}
                                            type="text"
                                            name="address"
                                            value={rangeDetails.address}
                                            onChange={(e) => onhandleChange(e)}
                                            label={t('reg.officeAddress')}

                                        />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                        pincode={rangeDetails?.pincode}
                                        state={rangeDetails.state}
                                        district={rangeDetails.district}
                                        revenueCircle={rangeDetails.revenueCircle}
                                        blockName={rangeDetails.blockName}
                                        onHandleCallback={getUpdatedAddressData}
                                        pincodeError={rangeErrorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleRangeChangeSelect}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mb={2} display='flex' alignItems="center" justifyContent="flex-end" mt={3} style={{ float: "right !important" }}>
                                {
                                    !showWorkFlowButtons && <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onCancel(e)} >{t('reg.cancel')}</Button>}
                                {
                                    !showWorkFlowButtons &&
                                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => checkValidations()}>{addEditBtnNameRange}
                                    </Button>}
                            </Grid>
                        </Grid>

                    }
                    {rangeDetailArray?.filter((item1) => item1.isActive === 1).map((item, index) =>

                        <Accordion >
                            <AccordionSummary sx={{
                                flexDirection: 'row-reverse',
                                backgroundColor: showCommentSection ? (item.growerForestBeatDetails.every(beatObj => beatDetailsSectionOk[beatObj.id] === true) ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                            }}
                                expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}>
                                <Stack ml={2} display="flex" alignItems="center" direction="row">
                                    {showCommentSection && (item.growerForestBeatDetails.every(beatObj => beatDetailsSectionOk[beatObj.id] === true) ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                                    <Typography variant="subtitle2" >Name: {item?.forestRangeOfficeName} - Pincode: {item?.pincode}</Typography>
                                </Stack>
                                {!showWorkFlowButtons && !showClarificationButton && <> <Tooltip title="Edit"><IconButton size='small' color="primary" disabled={!enableSaveSubmitButtons || viewOnly} onClick={(e) => onEditRangeDetails(e, item, index)} ><EditIcon /></IconButton></Tooltip>
                                    <Tooltip title="Delete">
                                        <IconButton disabled={!enableSaveSubmitButtons || viewOnly} size='small' color="error" aria-label="search"
                                            onClick={() => onDeleteRangeDetails(item)}  >
                                            <DeleteIcon color={!enableSaveSubmitButtons ? 'disabled' : 'error'} fontSize='small' />
                                        </IconButton></Tooltip></>}

                            </AccordionSummary>
                            <AccordionDetails>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                    {!showWorkFlowButtons && !showClarificationButton && <Button onClick={(e) => addnewBeat(item)} disabled={!enableSaveSubmitButtons || viewOnly} variant="contained" startIcon={<AddIcon />}>
                                        {t('reg.addNewBeat')}
                                    </Button>}
                                </Stack>
                                <TableContainer component={Paper}>
                                    <Table aria-label="collapsible table" sx={{ backgroundColor: "#FFFFFF" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell />
                                                <TableCell >{t('reg.forestBeatOffice')}</TableCell>
                                                <TableCell>{t('reg.forestBeatOfficer')}</TableCell>
                                                <TableCell>{t('reg.authorizedContactNo')}</TableCell>
                                                <TableCell>{t('reg.actions')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {newBeatObject.filter(newBeatObjFilterItem => newBeatObjFilterItem.forestRangeOfficeName === item.forestRangeOfficeName).concat(item?.growerForestBeatDetails?.filter((item1) => (item1.isActive === 1 || item1.isActive === 3)).map((child) => ({ ...child, parent: item }))).map((row) => (
                                                <>
                                                    <TableRow sx={{
                                                        '& > *': {
                                                            borderBottom: 'unset',
                                                            backgroundColor: showCommentSection ? (beatDetailsSectionOk[row.id] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF"
                                                        }
                                                    }}>
                                                        <TableCell>
                                                            <IconButton
                                                                aria-label="expand row"
                                                                size="small"
                                                                onClick={() => {
                                                                    setOpen((prevOpen) => ({
                                                                        ...Object.fromEntries(Object.entries(prevOpen).map(([id]) => [id, false])),
                                                                        [row.id]: !prevOpen[row.id],
                                                                    }));
                                                                    row.id === "noId" ? addnewBeat(item) : editBeatDetails(item, row);
                                                                }}
                                                            >
                                                                {open[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                {showCommentSection && (beatDetailsSectionOk[row.id] ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginLeft: "2vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginLeft: "2vh" }} />)}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>{row.forestBeatOfficeName}</TableCell>
                                                        <TableCell>{row.forestBeatOfficerName}</TableCell>
                                                        <TableCell>{row.authorizedContactPerson}</TableCell>
                                                        <TableCell> <>{enableFieldFunction(shouldActOnSectionBeat[row.id], false, false) &&
                                                            <Tooltip title="Delete">
                                                                <IconButton size='small' color="error" aria-label="search"
                                                                    onClick={() => onDeleteBeatDetails(item, row)} >
                                                                    <DeleteIcon color='error' fontSize='small' />
                                                                </IconButton>
                                                            </Tooltip>}
                                                        </></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                                                            <Collapse in={open[row.id]} timeout="auto" unmountOnExit>
                                                                <Grid container pb={3} pr={4} spacing={2} pl={1} direction="row" sx={{ backgroundColor: showCommentSection ? (beatDetailsSectionOk[selectedBeatId] ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103%" }}>
                                                                    <Grid item xs={12} style={{ marginBottom: "1em" }} alignItems="center">
                                                                        <Stack direction="row" alignItems="center">
                                                                            <Typography variant="h6" mt={3}>
                                                                                {t('reg.beatDetails')}
                                                                            </Typography>
                                                                        </Stack>
                                                                    </Grid>

                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={4} >
                                                                            <Grid container spacing={2}>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        error={beatErrorMessage.boundaryEastError}
                                                                                        helperText={beatErrorMessage.boundaryEastError}
                                                                                        type="text"
                                                                                        name="boundaryBeatEast"
                                                                                        value={beatDetails.boundaryBeatEast || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.boundaryEast')}

                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        error={beatErrorMessage.boundaryWestError}
                                                                                        helperText={beatErrorMessage.boundaryWestError}
                                                                                        type="text"
                                                                                        name="boundaryBeatWest"
                                                                                        value={beatDetails.boundaryBeatWest || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.boundaryWest')}

                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        error={beatErrorMessage.boundaryNorthError}
                                                                                        helperText={beatErrorMessage.boundaryNorthError}
                                                                                        type="text"
                                                                                        name="boundaryBeatNorth"
                                                                                        value={beatDetails.boundaryBeatNorth || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.boundaryNorth')}

                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        error={beatErrorMessage.boundarySouthError}
                                                                                        helperText={beatErrorMessage.boundarySouthError}
                                                                                        type="text"
                                                                                        name="boundaryBeatSouth"
                                                                                        value={beatDetails.boundaryBeatSouth || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.boundarySouth')}

                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={4} >
                                                                            <Grid container spacing={2}>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        error={beatErrorMessage.beatOfficeNameError}
                                                                                        helperText={beatErrorMessage.beatOfficeNameError}
                                                                                        type="text"
                                                                                        disabled={addEditBtnNameBeat === "Update Beat" || !enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        name="forestBeatOfficeName"
                                                                                        value={beatDetails.forestBeatOfficeName || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.forestBeatOffice')}

                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        error={beatErrorMessage.beatOfficerError}
                                                                                        helperText={beatErrorMessage.beatOfficerError}
                                                                                        type="text"
                                                                                        name="forestBeatOfficerName"
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        value={beatDetails.forestBeatOfficerName || ''}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.forestBeatOfficer')}

                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        error={beatErrorMessage.beatAuthorizedContactError}
                                                                                        helperText={beatErrorMessage.beatAuthorizedContactError}
                                                                                        type="number"
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        onFocus={handleNumberFieldFocus}
                                                                                        name="authorizedContactPerson"
                                                                                        value={beatDetails.authorizedContactPerson}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.authorizedContactNo')}
                                                                                        onKeyDown={(evt) => typeNumberValid(evt)}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid item xs={4} >
                                                                            <Grid container spacing={2}>
                                                                                <Grid item xs={12}>
                                                                                    <TextField fullWidth
                                                                                        required
                                                                                        multiline
                                                                                        disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                        error={beatErrorMessage.addressError}
                                                                                        helperText={beatErrorMessage.addressError}
                                                                                        type="text"
                                                                                        name="address"
                                                                                        value={beatDetails.address}
                                                                                        onChange={(e) => handleBeatChange(e)}
                                                                                        label={t('reg.officeAddress')}

                                                                                    />
                                                                                </Grid>
                                                                                <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                                                                    isDisabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                    pincode={beatDetails?.pincode}
                                                                                    state={beatDetails.state}
                                                                                    district={beatDetails.district}
                                                                                    revenueCircle={beatDetails.revenueCircle}
                                                                                    blockName={beatDetails.blockName}
                                                                                    onHandleCallback={setBeatAddressData}
                                                                                    pincodeError={beatErrorMessage.pincodeError}
                                                                                    searchError={errorMessage.searchError}
                                                                                    handleChangeSelect={handleBeatChangeSelect}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Divider sx={{
                                                                        width: '105%',
                                                                        bgcolor: "black",
                                                                        marginTop: '3vh',
                                                                        color: 'red'
                                                                    }} mt={2} />
                                                                    <Grid item xs={12}>
                                                                        <Typography sx={{ mt: 2 }} variant="subtitle2">{t('reg.forestCoupeAvailable')}</Typography>
                                                                        <Stack direction='horizontal' gap={1}>
                                                                            <FormControl >
                                                                                <RadioGroup
                                                                                    row
                                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                    name="row-radio-buttons-group"
                                                                                >
                                                                                    <FormControlLabel control={<Radio disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)} name="isForestCoupeAvailable" checked={beatDetails.isForestCoupeAvailable === true} onChange={(e) => radioChange(e, true)} />} label={t('reg.yes2')} />
                                                                                    <FormControlLabel control={<Radio disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)} name="isForestCoupeAvailable" checked={beatDetails.isForestCoupeAvailable === false} onChange={(e) => radioChange(e, false)} />} label={t('reg.no2')} />
                                                                                </RadioGroup>
                                                                            </FormControl>
                                                                        </Stack>
                                                                    </Grid>

                                                                    {beatDetails.isForestCoupeAvailable === true ? <>
                                                                        <Grid item xs={12} >
                                                                            <Stack direction="row" gap={1}>
                                                                                <Autocomplete sx={{ width: "35ch" }}
                                                                                    multiple
                                                                                    disableCloseOnSelect
                                                                                    options={availableCoupes}
                                                                                    disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                    getOptionLabel={(option) => option?.coupeName}
                                                                                    onChange={(e, value) => onCoupeAdded(e, value)}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label={t('reg.selectCoupes')}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                                <Button sx={{ ml: 2 }} variant="contained" disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)} onClick={(e) => onAddCoupe(e)}>{t('reg.add')}</Button>
                                                                            </Stack>
                                                                        </Grid>
                                                                        <Grid xs={12}>
                                                                            <Box style={{ height: 300 }} mt={2}>
                                                                                <DataGrid
                                                                                    rows={beatDetails?.regForestBeatSeriesCoupeDetails?.filter(x => x.isActive === 1)}
                                                                                    columns={coupeFellingColumns}
                                                                                    pageSize={5}
                                                                                    components={{
                                                                                        Toolbar: CustomDataGridToolbar,
                                                                                    }}
                                                                                    componentsProps={{ toolbar: { rows: beatDetails?.regForestBeatSeriesCoupeDetails?.filter(x => x.isActive === 1), columns: coupeFellingColumns, fileName: "CoupeDetails.xlsx" } }}
                                                                                    getRowId={(row) => row?.regForestCoupe?.coupeName}
                                                                                />
                                                                            </Box>
                                                                        </Grid>
                                                                    </>
                                                                        :
                                                                        <>
                                                                            <Grid container spacing={1} direction="row">
                                                                                <Grid item xs={12}>
                                                                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                                                                        <Button onClick={(e) => addnewLandBtnClick(e)} variant="contained" startIcon={<AddIcon />}>
                                                                                            {t('reg.addNewLand')}
                                                                                        </Button>
                                                                                    </Stack>
                                                                                </Grid>
                                                                                <Grid item xs={12}>
                                                                                    {!showLandSection && <Box style={{ height: 400 }} mt={2}>
                                                                                        <DataGrid
                                                                                            rows={selectedBeat?.regForestBeatLandDetails?.filter((item1) => item1.isActive === 1)}
                                                                                            columns={landColumns}
                                                                                            pageSize={5}
                                                                                            components={{
                                                                                                Toolbar: CustomDataGridToolbar,
                                                                                            }}
                                                                                            componentsProps={{ toolbar: { rows: selectedBeat?.regForestBeatLandDetails?.filter((item1) => item1.isActive === 1), columns: landColumns, fileName: "LandDetails.xlsx" } }}
                                                                                            getRowId={(row) => row.landName}
                                                                                        />
                                                                                    </Box>}
                                                                                </Grid>
                                                                            </Grid>
                                                                            {showLandSection &&
                                                                                <>
                                                                                    <Typography variant="h6" mt={2} ml={2} style={{ marginBottom: "1em" }} gutterBottom>
                                                                                        {t('reg.beatLandDetails')}
                                                                                    </Typography>
                                                                                    <div className='mandatory_field'>{landErrorMessage.saveError}</div>
                                                                                    <Card>
                                                                                        <CardContent>
                                                                                            <Grid container spacing={2}>
                                                                                                <Grid item xs={4} >
                                                                                                    <Grid container spacing={2}>
                                                                                                        <Grid item xs={12}>
                                                                                                            <TextField fullWidth
                                                                                                                required
                                                                                                                multiline
                                                                                                                error={landErrorMessage?.addressError}
                                                                                                                helperText={landErrorMessage?.addressError}
                                                                                                                // disabled={isDisabled()}
                                                                                                                type="input"
                                                                                                                label={t('main.address')}
                                                                                                                name="address"
                                                                                                                value={landDetails?.address}
                                                                                                                onChange={(e) => handleLandChange(e)}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                        <CommonPincodeMUI setErrorMessage={setErrorMessage}
                                                                                                            pincode={landDetails?.pincode}
                                                                                                            state={landDetails.state}
                                                                                                            district={landDetails.district}
                                                                                                            revenueCircle={landDetails.revenueCircle}
                                                                                                            blockName={landDetails.blockName}
                                                                                                            onHandleCallback={setLandAddressData}
                                                                                                            pincodeError={landErrorMessage.pincodeError}
                                                                                                            searchError={landErrorMessage.searchError}
                                                                                                            handleChangeSelect={handleLandChangeSelect}
                                                                                                        />
                                                                                                        <Grid item xs={12}>
                                                                                                            <FormControl required>
                                                                                                                <FormLabel>{t('reg.captive')}</FormLabel>
                                                                                                                <RadioGroup
                                                                                                                    row
                                                                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                                                    name="row-radio-buttons-group"
                                                                                                                >
                                                                                                                    <FormControlLabel control={<Radio name="captive" checked={landDetails.captive === true} onChange={(e) => landRadioChange(e, true)} />} label={t('preReg.yes')} />
                                                                                                                    <FormControlLabel control={<Radio name="captive" checked={landDetails.captive === false} onChange={(e) => landRadioChange(e, false)} />} label={t('preReg.no')} />
                                                                                                                </RadioGroup>
                                                                                                            </FormControl>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={6} hidden={!landDetails?.captive}>
                                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                                <DesktopDatePicker fullWidth
                                                                                                                    required
                                                                                                                    label={t('reg.startDate')}
                                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                                    value={captiveStartDateDisplay}
                                                                                                                    name="captiveStartDate"
                                                                                                                    onChange={(e) => handleDateChange(e, "captiveStartDate")}
                                                                                                                    renderInput={(params) => <TextField {...params} />}
                                                                                                                />
                                                                                                                <FormHelperText sx={{ color: 'red' }}>{landErrorMessage.captiveStartDateError}</FormHelperText>
                                                                                                            </LocalizationProvider>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={6} hidden={!landDetails?.captive}>
                                                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                                <DesktopDatePicker
                                                                                                                    required
                                                                                                                    label={t('reg.endDate')}
                                                                                                                    inputFormat="DD/MM/YYYY"
                                                                                                                    value={captiveEndDateDisplay}
                                                                                                                    name="captiveEndDate"
                                                                                                                    minDate={captiveStartDateDisplay}
                                                                                                                    onChange={(e) => handleDateChange(e, "captiveEndDate")}
                                                                                                                    renderInput={(params) => <TextField {...params} />}
                                                                                                                />
                                                                                                                <FormHelperText sx={{ color: 'red' }}>{landErrorMessage.captiveEndDateError}</FormHelperText>
                                                                                                            </LocalizationProvider>
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid item xs={4} >
                                                                                                    <Grid container spacing={2}>
                                                                                                        <Grid item xs={12}>
                                                                                                            <TextField fullWidth
                                                                                                                required
                                                                                                                error={landErrorMessage.landAreaError}
                                                                                                                helperText={landErrorMessage.landAreaError}
                                                                                                                type="number"
                                                                                                                onFocus={handleNumberFieldFocus}
                                                                                                                disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                                                label={t('preReg.existingLandArea')}
                                                                                                                name="landAreaValue"
                                                                                                                value={landAreaValue}
                                                                                                                onChange={(e) => handleLandChange(e)}
                                                                                                                InputProps={{
                                                                                                                    endAdornment: (
                                                                                                                        <Select
                                                                                                                            variant="standard"
                                                                                                                            size="small"
                                                                                                                            name="landAreaUnit"
                                                                                                                            disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                                                            value={landAreaUnit}
                                                                                                                            onChange={(e) => handleLandChange(e)}
                                                                                                                        >
                                                                                                                            {LAND_AREA_UNIT.map((option) => (
                                                                                                                                <MenuItem key={option} value={option}>
                                                                                                                                    {option}
                                                                                                                                </MenuItem>
                                                                                                                            ))}
                                                                                                                        </Select>
                                                                                                                    ),
                                                                                                                }}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <TextField fullWidth
                                                                                                                required
                                                                                                                error={landErrorMessage?.landNameError}
                                                                                                                helperText={landErrorMessage?.landNameError}
                                                                                                                name="landName"
                                                                                                                onChange={(e) => handleLandChange(e)}
                                                                                                                value={landDetails?.landName}
                                                                                                                label={t('reg.landName')}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <FormControl required>
                                                                                                                <FormLabel>{t('reg.landType')}</FormLabel>
                                                                                                                <RadioGroup
                                                                                                                    row
                                                                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                                                    name="row-radio-buttons-group"
                                                                                                                >
                                                                                                                    <FormControlLabel value="Hilly" control={<Radio className='input_label' name="landType" checked={landDetails?.landType === "Hilly"} onChange={(e) => handleLandChange(e)} />} label={t('reg.hilly')} />
                                                                                                                    <FormControlLabel value="Plain" control={<Radio className='input_label' name="landType" checked={landDetails?.landType === "Plain"} onChange={(e) => handleLandChange(e)} />} label={t('reg.plain')} />
                                                                                                                    <FormControlLabel value="Trench" control={<Radio className='input_label' name="landType" checked={landDetails?.landType === "Trench"} onChange={(e) => handleLandChange(e)} />} label={t('reg.trench')} />
                                                                                                                </RadioGroup>
                                                                                                            </FormControl>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Tooltip title="Difficulty in harvesting and transportation" arrow>
                                                                                                                <FormControl fullWidth required error={errorMessage?.easeOfSourcingError}>
                                                                                                                    <InputLabel>{t('reg.easeOfSourcing')}</InputLabel>
                                                                                                                    <Select
                                                                                                                        label="Ease of sourcing"
                                                                                                                        name="easeOfSourcing"
                                                                                                                        value={landDetails?.easeOfSourcing || ""}
                                                                                                                        onChange={(e) => handleLandChange(e)}>
                                                                                                                        {
                                                                                                                            SOURCING?.map((item) =>
                                                                                                                                <MenuItem value={item}>{item}</MenuItem>
                                                                                                                            )
                                                                                                                        }
                                                                                                                    </Select>
                                                                                                                    {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.easeOfSourcingError}</FormHelperText> */}
                                                                                                                </FormControl>
                                                                                                            </Tooltip>
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <FormControl required>
                                                                                                                <FormLabel>{t('reg.sidingRequirement')}</FormLabel>
                                                                                                                <RadioGroup
                                                                                                                    row
                                                                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                                                    name="row-radio-buttons-group"
                                                                                                                >
                                                                                                                    <FormControlLabel control={<Radio name="sidingRequirement" checked={landDetails.sidingRequirement === true} onChange={(e) => landRadioChange(e, true)} />} label={t('reg.yes2')} />
                                                                                                                    <FormControlLabel control={<Radio name="sidingRequirement" checked={landDetails.sidingRequirement === false} onChange={(e) => landRadioChange(e, false)} />} label={t('reg.no2')} />
                                                                                                                </RadioGroup>
                                                                                                            </FormControl>
                                                                                                        </Grid>
                                                                                                        {landDetails?.sidingRequirement === true && <Grid item xs={12}>
                                                                                                            {/* <Typography variant='caption'>Distance in meters to the nearest vehicle motorable point for loading</Typography> */}
                                                                                                            <TextField fullWidth
                                                                                                                required
                                                                                                                error={landErrorMessage?.sidingDistanceInMtrsError}
                                                                                                                helperText={landErrorMessage?.sidingDistanceInMtrsError}
                                                                                                                label={t('reg.sidingRequirementInMeter')}
                                                                                                                name="sidingDistanceInMtrs"
                                                                                                                type="number" onFocus={handleNumberFieldFocus} onKeyDown={(evt) => typeNumberValid(evt)}
                                                                                                                onFocus={handleNumberFieldFocus}
                                                                                                                disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)}
                                                                                                                value={landDetails?.sidingDistanceInMtrs}
                                                                                                                onChange={(e) => handleLandChange(e)} />
                                                                                                        </Grid>}
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                                <Grid item xs={4}>
                                                                                                    <Grid container spacing={2}>
                                                                                                        <Grid item xs={12} mt={1}>
                                                                                                                <LocationPointMUI
                                                                                                                    latitudeLabel="Latitude"
                                                                                                                    longitudeLabel="Longitude"
                                                                                                                    latitudeName={t('preReg.latitude')}
                                                                                                                    longitudeName={t('preReg.longitude')}
                                                                                                                    latitude={landDetails?.geocodeLattitude}
                                                                                                                    longitude={landDetails?.geocodeLongitude}
                                                                                                                    callBackLocation={onLocationPoint}
                                                                                                                    latitudesError={errorMessage.latitudesError}
                                                                                                                    longitudesError={errorMessage.longitudesError}
                                                                                                                />
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <FileUploadMUI key="LandPics"
                                                                                                                documentList={documentArray}
                                                                                                                documentType="LandPics"
                                                                                                                callBackDocumentUpload={onUploadCallBack}
                                                                                                                stakeholderDetailId={landDetails?.id}
                                                                                                                stakeholderType="growerLand"
                                                                                                                title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                                                                                                                errorMessage={errorMessage}
                                                                                                                setErrorMessage={setErrorMessage}
                                                                                                                documentError="locationDocError"
                                                                                                            />
                                                                                                            {/* <div className='mandatory_field'>{landErrorMessage.locationDocError}</div> */}
                                                                                                        </Grid>
                                                                                                        <Grid item xs={12}>
                                                                                                            <FileUploadMUI key="LandDocument"
                                                                                                                documentList={documentArray}
                                                                                                                documentType="LandDocument"
                                                                                                                callBackDocumentUpload={onUploadCallBack}
                                                                                                                stakeholderDetailId={landDetails?.id}
                                                                                                                stakeholderType="growerLand"
                                                                                                                title={t('reg.uploadLandForestMapDoc')}
                                                                                                                errorMessage={errorMessage}
                                                                                                                setErrorMessage={setErrorMessage}
                                                                                                                documentError="landdocError"

                                                                                                            />
                                                                                                            {/* <div className='mandatory_field'>{landErrorMessage.landdocError}</div> */}
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                            <Grid item xs={12} >
                                                                                                <Accordion mt={1}>
                                                                                                    <AccordionSummary
                                                                                                        expandIcon={<AccordionIcon />}
                                                                                                    >
                                                                                                        <Typography variant="subtitle1" >Bamboo Species Details</Typography>
                                                                                                    </AccordionSummary>
                                                                                                    <AccordionDetails>
                                                                                                        <Grid item xs={12}>
                                                                                                            <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                                                                                                                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                                                                                                    {/* <Typography variant="h6" gutterBottom>
                                                                                                                                Bamboo Species Details
                                                                                                                            </Typography> */}
                                                                                                                </Stack>
                                                                                                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                                                                                                                    <Button onClick={(e) => addBamboo(e)} variant="contained" startIcon={<AddIcon />}>
                                                                                                                        {t('reg.addBambooDetails')}
                                                                                                                    </Button>
                                                                                                                </Stack>
                                                                                                            </Stack>
                                                                                                            <DataGrid
                                                                                                                sx={{
                                                                                                                    "& .MuiDataGrid-columnHeaderTitle": {
                                                                                                                        whiteSpace: "normal",
                                                                                                                        lineHeight: "normal"
                                                                                                                    },
                                                                                                                    "& .MuiDataGrid-columnHeader": {
                                                                                                                        height: "unset !important"
                                                                                                                    },
                                                                                                                    "& .MuiDataGrid-columnHeaders": {
                                                                                                                        maxHeight: "168px !important"
                                                                                                                    }
                                                                                                                }}
                                                                                                                autoHeight
                                                                                                                rows={((landDetails?.growerForestBambooSpecies)?.filter(o1 => (bambooSpeciesRes)?.some(o2 => o1.bambooSpecies === o2.id & o1.isActive === 1)))}
                                                                                                                pagination={false}
                                                                                                                hideFooterPagination
                                                                                                                columns={columns}
                                                                                                                disableColumnMenu={true}
                                                                                                                experimentalFeatures={{ newEditingApi: true }}
                                                                                                                getRowId={(row) => row.bambooSpecies}
                                                                                                            />
                                                                                                        </Grid>
                                                                                                    </AccordionDetails>
                                                                                                </Accordion>
                                                                                            </Grid>
                                                                                        </CardContent>
                                                                                    </Card>

                                                                                    <Grid item xs={12} display='flex' mr={2} mt={3} alignItems="center" justifyContent="flex-end" style={{ float: "right" }}>
                                                                                        <Button mr={2} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onLandCancel(e)}>{t('reg.cancel')}</Button>
                                                                                        <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => onLandSubmit()}>{addEditBtnNameLand}</Button>
                                                                                    </Grid>
                                                                                </>

                                                                            }
                                                                        </>}
                                                                </Grid>
                                                                {showCommentSection && <>
                                                                    <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                                                                        <Grid item xs={7}>
                                                                            <TextField sx={{ width: "100%" }}
                                                                                label={t('reg.comment')}
                                                                                name="comment"
                                                                                inputProps={{
                                                                                    maxLength: 300,
                                                                                }}
                                                                                multiline
                                                                                disabled={selectedForestBeatOfficerName && !shouldActOnSectionBeat[selectedBeatId]}
                                                                                value={beatComment}
                                                                                onChange={(e) => setBeatComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                                                                            />
                                                                            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                                                                                <Badge bg={`${beatComment?.length > characterLimit ? 'danger' : 'primary'}`}>{beatComment?.length}/{characterLimit}</Badge>
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <FormGroup>
                                                                                <FormControlLabel control={<Switch disabled={selectedForestBeatOfficerName && !shouldActOnSectionBeat[selectedBeatId]} checked={beatDetailsSectionOk[selectedBeatId]}
                                                                                    onChange={(e) => setBeatDetailsSectionOk({ ...beatDetailsSectionOk, [selectedBeatId]: e.target.checked })} />} label={<Typography variant="subtitle2" gutterBottom>
                                                                                        {t('reg.detailsOk')}?
                                                                                    </Typography>} />
                                                                            </FormGroup>
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                            <Button variant="contained" disabled={selectedForestBeatOfficerName && !shouldActOnSectionBeat[selectedBeatId]}
                                                                                onClick={() => onSaveComment(beatComment)}
                                                                                startIcon={<CommentIcon />}
                                                                            >
                                                                                {t('preReg.addComment')}
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <div>
                                                                        <Accordion mt={1}>
                                                                            <AccordionSummary
                                                                                expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                                                                            >
                                                                                <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                                                                            </AccordionSummary>
                                                                            <AccordionDetails>
                                                                                <Box style={{ height: 300, width: '100%' }}>
                                                                                    <DataGrid
                                                                                        rows={comments ? comments?.filter((item) => item.sectionName === "beat_details" && item.sectionId === selectedBeatId) : []}
                                                                                        columns={commentsColumn}
                                                                                        pageSize={10}
                                                                                        getRowHeight={() => 'auto'}
                                                                                    />
                                                                                </Box>
                                                                            </AccordionDetails>
                                                                        </Accordion>
                                                                    </div>
                                                                </>}
                                                                <div className='mandatory_field'>{errorMessage.submitError}</div>
                                                                {!showWorkFlowButtons && <Box display='flex' alignItems="center" justifyContent="flex-end" mt={3} style={{ float: "right" }}>
                                                                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onCancel(e)} >{t('reg.cancel')}</Button>
                                                                    <Button sx={{ minWidth: 100, ml: 1 }} disabled={!enableFieldFunction(shouldActOnSectionBeat[selectedBeatId], false, selectedForestBeatOfficerName ? false : true)} variant="contained" onClick={() => onBeatSubmit()}>{addEditBtnNameBeat}
                                                                    </Button>
                                                                </Box>}
                                                            </Collapse>
                                                        </TableCell >
                                                    </TableRow>
                                                </>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>)}
                </AccordionDetails>
            </Accordion >
        </Grid >
    )
}

export default RangeDetailsForest;